import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
})
export class InputComponent {
  @Input()
  id: string = '';

  @Input()
  label: string = '';

  @Input()
  placeholder: string = '';

  @Input()
  required: boolean = false;

  @Input()
  searchForm!: NgForm;

  @Input()
  type: string = '';

  @Input()
  validationErrorMessage: string = '';

  @Output()
  updateValue: EventEmitter<string> = new EventEmitter();

  value: string = '';

  public onInputChange(): void {
    this.updateValue.emit(this.value);
  }
}
